import { Component,ViewChild, ChangeDetectorRef } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { Applicants } from '../applicants/Applicants';
import { AcademicYear } from '../applicants/AcademicYear';
import { ProgrammeType } from '../common/programmeType';
import { Programme } from '../applicant/programme';
import { Router } from '@angular/router';
import { CommonService } from '../common/common.services';
import { ProgrammeSelectionService } from '../accepted-applicants/programme-selection.service';
import { AllApplicantsService } from '../applicants/applicants.service';
// import * as saveAs from 'file-saver';
// @ts-ignore
import saveAs from 'file-saver';
import { RegisteredApplicantsService } from './registered-applicants.service';
import { ToastrService } from 'ngx-toastr';
import * as XLSX from 'xlsx';


@Component({
  selector: 'app-registered-applicants',
  templateUrl: './registered-applicants.component.html',
  styleUrls: ['./registered-applicants.component.scss'],
})
export class RegisteredApplicantsComponent {
  @ViewChild('paginator') paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  isHandset$: Observable<boolean> = this.breakpointObserver
  .observe(Breakpoints.Handset)
  .pipe(
      map((result) => result.matches),
      shareReplay(),
    );
  displayedColumns: string[] = [
    'id',
    'Applicant',
    'ProgrammeType',
    'Reg.Number',
    'Country',
    'Hometown',
    'Sex',
    'Date',
    'Semester',
    'Status',
  ];

  //dataSource: MatTableDataSource<Applicants>;
  dataSource: MatTableDataSource<Applicants> = new MatTableDataSource([]);

  year: string;
  programmeTypeId: string;
  programmeId: string;
  years: AcademicYear[];
  programmeTypeList: ProgrammeType[];
  programmeList: Programme[];
  registeredApplicantList: Applicants[];
  totalApplicants: number;
  totalCertificateApplicants: number;
  totalDegreeApplicants: number;
  totalDiplomaApplicants: number;
  degreeApplicants: Applicants[];
  diplomaApplicants: Applicants[];
  certificateApplicants: Applicants[];
  sortedApplicantList: Applicants[];
  unSortedApplicantList: Applicants[];


  constructor(
    private router: Router,
    private commonService: CommonService,
    private programmeSelectionService: ProgrammeSelectionService,
    private allApplicantsService: AllApplicantsService,
    private breakpointObserver: BreakpointObserver,
    private registeredApplicantsService: RegisteredApplicantsService,
    private toaster:ToastrService,
    private cdr: ChangeDetectorRef 
  ) {}

  public loading = false;
  ngOnInit(): void {
    this.loading = true;
    this.allApplicantsService.getCurrentYear().subscribe((currentYear) => {
      console.log(currentYear.response);
      this.allApplicantsService.getAcademicYears().subscribe((response) => {
        this.years = response;
        this.year = currentYear.response;
        this.programmeSelectionService
          .getProgrammeList()
          .subscribe((programmeList) => {
            this.programmeList = programmeList;
          });
        this.commonService
          .getProgrammeTypes()
          .subscribe((programmeTypeList) => {
            this.programmeTypeList = programmeTypeList;
          });
          setTimeout(()=>{
            this.loading = true;
            const internetError = Math.random() < 0.2;
            if (internetError) {
              // Handle the internet error
              this.toaster.info('Internet error: Unable to fetch data.','Internet Server',{
                positionClass: 'toast-top-center', 
              });
            } else {
              // Continue with the normal operation 
            }

            this.fetchApplicantList();
            this.loading = false;
          }, 3000);
      });
    });
  }

  fetchApplicantList() {
    this.allApplicantsService
      .getAllApplicants(this.year)
      .subscribe((response) => {
        this.registeredApplicantList = response.filter(
          (applicant) => applicant.status === 'REGISTERED',
        );
            // Update dataSource with new data
        this.dataSource = new MatTableDataSource(this.registeredApplicantList);
        //console.log(this.registeredApplicantList);
        
        this.totalApplicants = this.registeredApplicantList.length;

          // Update other related variables
          this.totalApplicants = this.registeredApplicantList.length;
          this.totalDiplomaApplicants = this.registeredApplicantList.filter(
            (applicant) => applicant.programmeType.includes('Diploma')
          ).length;
          this.totalDegreeApplicants = this.registeredApplicantList.filter(
            (applicant) => applicant.programmeType.includes('Bachelor')
          ).length;
          this.totalCertificateApplicants = this.registeredApplicantList.filter(
            (applicant) => applicant.programmeType.includes('Certificate')
          ).length;
        });
  }


  populateApplicants(type: string): void {
    console.log('displaying data for: ' + type);
  
    switch (type) {
      case 'All':
        // show all applicants
        this.unSortedApplicantList = this.registeredApplicantList;
        break;
      case 'Bachelor':
        // show Degree applicants
        this.unSortedApplicantList = this.registeredApplicantList.filter(
          (applicant) => applicant.programmeType.includes('Bachelor')
        );
        break;
      case 'Diploma':
        // show diploma
        this.unSortedApplicantList = this.registeredApplicantList.filter(
          (applicant) => applicant.programmeType.includes('Diploma')
        );
        break;
      case 'Certificate':
        // show certificates
        this.unSortedApplicantList = this.registeredApplicantList.filter(
          (applicant) => applicant.programmeType.includes('Certificate')
        );
        break;
      default:
        // Handle unexpected types or default to displaying all applicants
        this.unSortedApplicantList = this.registeredApplicantList;
        break;
    }
  
    // Update the MatTableDataSource and associated components
    this.dataSource.data = this.unSortedApplicantList;
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.cdr.detectChanges(); // triggers
  }
  

  fetchApplicantTypeListForYear(year: string) {
    this.year = year;
    this.fetchApplicantList();
    this.fetchRegisteredApplicants(
      this.year,
      this.programmeTypeId,
      this.programmeId,
    );
  }

  fetchApplicantTypeListForProgrammeId(programmeId: string) {
    this.programmeId = programmeId;
    this.fetchApplicantList();
    this.fetchRegisteredApplicants(
      this.year,
      this.programmeTypeId,
      this.programmeId,
    );
  }

  fetchApplicantTypeListForProgrammeTypeId(programmeTypeId: string) {
    this.programmeTypeId = programmeTypeId;
    this.fetchApplicantList();
    this.fetchRegisteredApplicants(
      this.year,
      this.programmeTypeId,
      this.programmeId,
    );
  }

  fetchRegisteredApplicants(
    year: string,
    programmeTypeId: string,
    programmeId: string,
  ) {
    if (
      year !== undefined &&
      programmeTypeId !== undefined &&
      programmeId !== undefined
    ) {
      this.registeredApplicantsService
        .getRegisteredApplicantList(year, programmeId, programmeTypeId)
        .subscribe((applicants) => {
          this.registeredApplicantList = applicants;
          this.unSortedApplicantList = this.registeredApplicantList;
          this.dataSource = new MatTableDataSource(this.unSortedApplicantList);
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
        });
    } else if (
      year !== undefined &&
      programmeTypeId === undefined &&
      programmeId === undefined
    ) {
      this.allApplicantsService
        .getAllApplicants(this.year)
        .subscribe((response) => {
          this.registeredApplicantList = response.filter(
            (applicant) => applicant.status === 'REGISTERED',
          );
          this.dataSource = new MatTableDataSource(this.registeredApplicantList);
          this.dataSource.paginator = this.paginator;
        });
    }
  }

  goToApplicantDetails(applicantId: string) {
    this.router.navigateByUrl(
      '/applicant?applicantId=' + applicantId + '&year=' + this.year,
    );
  }

  sortData(sort: Sort) {
    this.sortedApplicantList = this.registeredApplicantList.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'id':
          return this.commonService.compare(a.personId, b.personId, isAsc);
        case 'Applicant':
          return this.commonService.compare(
            a.applicantName,
            b.applicantName,
            isAsc,
          );
        case 'ProgrammeType':
          return this.commonService.compare(
            a.programmeType,
            b.programmeType,
            isAsc,
          );
        case 'ProgrammeTitle':
          return this.commonService.compare(a.programme, b.programme, isAsc);
        case 'Country':
          return this.commonService.compare(a.country, b.country, isAsc);
        case 'City':
          return this.commonService.compare(a.hometown, b.hometown, isAsc);
        case 'Sex':
          return this.commonService.compare(a.gender, b.gender, isAsc);
        case 'Status':
          return this.commonService.compare(a.status, b.status, isAsc);
        default:
          return 0;
      }
    });

    this.dataSource = new MatTableDataSource(this.sortedApplicantList);
  }

  applyFilter(filterValue: string) {
    if (this.dataSource) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
    }
  }
  get filteredRowCount(): number {
    return this.dataSource ? this.dataSource.filteredData.length : 0;
  }

  downloadExcelFile() {
    this.allApplicantsService
      .getAllRegisteredApplicantsExcelFile(this.year)
      .subscribe((blob) => {
        saveAs(blob, 'AUCDT Registered Applicants.xlsx');
      });
  }

exportExcel(): void {
  const data: any[] = this.unSortedApplicantList;
  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const workbook: XLSX.WorkBook = { Sheets: {'AUCDT_Registered_Applicants':worksheet}, SheetNames: ['AUCDT_Registered_Applicants'] };
  const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  this.saveAsExcelFile(excelBuffer, 'AUCDT_Registered_Applicants');
}

private saveAsExcelFile(buffer: any, fileName: string): void {
  const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
  const a: HTMLAnchorElement = document.createElement('a');
  document.body.appendChild(a);
  a.href = URL.createObjectURL(data);
  a.download = `${fileName}.xlsx`;
  a.click();
}

 
}
